import { userListChangeListener } from 'features/users/listeners/userListChangeListener';
import { AppStartListening } from 'store/listenerMiddleware';

export const addUsersListeners = (startListening: AppStartListening) => {
  userListChangeListener(startListening);
};
